import React from 'react';
import FinalForm from '@/Framework/UI/Organisms/FinalForm';
import {
  PORTFOLIO_OPTIONAL_DATA_FIELD_ARRAY,
  PORTFOLIO_OPTIONAL_DATA_FORM,
} from './constants';
import OptionalDataFields from './OptionalDataFields';
import useGetPositions from '@/finsight/ui/components/portfolioMonitor/PortfolioContent/common/useGetPositions';
import { useFormPayloadContext } from '@/finsight/application/PortfolioMonitor/FormPayloadContext';
import { usePortfoliosContext } from '@/finsight/application/PortfolioMonitor/PortfoliosContext';
import { usePortfolioMonitorContext } from '@/finsight/application/PortfolioMonitor/PortfolioMonitorContext';
import { validate } from './validators';

import formStyles from '@/finsight/ui/components/portfolioMonitor/PortfolioContent/PortfolioForm/formStyles.scss';

const OptionalDataTable = (props) => {
  const { positions, listIndex } = useGetPositions();
  const { payload, setPayload } = useFormPayloadContext();
  const { createPortfolio, getPortfolioCollection, hasPortfolio } = usePortfoliosContext();
  const { setIsFormOpened } = usePortfolioMonitorContext();

  const submit = async (values) => {
    setPayload((prevState) => {
      prevState.lists[listIndex].positions = values[PORTFOLIO_OPTIONAL_DATA_FIELD_ARRAY];
      return prevState;
    });

    await createPortfolio(payload, hasPortfolio);
    await getPortfolioCollection();
    setPayload({});
    setIsFormOpened((prev) => !prev);
  };

  return (
    <FinalForm
      name={ PORTFOLIO_OPTIONAL_DATA_FORM }
      className={ formStyles.virtualListContainer }
      dataTest={ PORTFOLIO_OPTIONAL_DATA_FORM }
      render={ () => <OptionalDataFields { ...props } /> }
      onSubmit={ submit }
      initialValues={ { [PORTFOLIO_OPTIONAL_DATA_FIELD_ARRAY]: positions } }
      validate={ validate }
    />
  );
};

export default OptionalDataTable;
